// Size variants for the pick-resource scrollable list: `scrollable` styles the scroll container,
// `content` the box inside it that the list renders into.
//
// `default` reserves space for a single filter row (used by the template picker). It hardcodes a
// footer's worth of space into the budget, since GPickResourceModal always renders primary/secondary
// actions below the list -- nothing pins the dialog's own height there, so the list's fixed calc is
// what the whole modal's height adds up to. That only holds for a header of fixed height: a row that
// comes and goes has to be named in the budget to the pixel, or the dialog jumps as it toggles --
// use `fillPinnedDialog` for those.
export const PICK_RESOURCE_SCROLL_VARIANT = {
  default: {
    scrollable:
      'max-h-[calc(100vh-264px-var(--shopify-safe-area-inset-bottom,0px))] md:max-h-[calc(80vh-194px)]',
    content:
      'min-h-[calc(100vh-264px-var(--shopify-safe-area-inset-bottom,0px))] md:min-h-[calc(80vh-194px)]',
  },
  // For a modal whose dialog height is pinned by its own ancestor CSS instead (see the
  // `:has(.modal-edit-experiments-identifier)` rule in AssetTemplate.scss and the
  // `:has(.modal-pick-page-identifier)` one in ModalPickPage.scss, both of which also carry the flex
  // chain down to here). A calc budget would have to guess at the header and footer, so the list
  // takes the pinned height's remainder instead: `flex-1` to claim it, `min-h-0` to still scroll
  // rather than stretch past it, and `min-h-full` so a short list's empty state fills rather than
  // collapses. Named `fillPinnedDialog`, not `fill`: this only works when an ancestor supplies that
  // flex chain and pins the dialog's own height, which no CSS owned by GPickResourceModal itself
  // guarantees -- use elsewhere requires bringing the same ancestor setup.
  fillPinnedDialog: {
    scrollable: 'min-h-0 flex-1',
    content: 'min-h-full',
  },
} as const;

export const DEFAULT_CANCEL_CONTENT = 'Cancel';
